import { ACCREDITATIONS } from "../../data/homeData";

const Accreditations = () => {
  // The marquee needs two copies of the list for a seamless loop. The
  // second copy is marked aria-hidden so screen readers announce each
  // partner exactly once instead of hearing every name twice.
  const items = [...ACCREDITATIONS, ...ACCREDITATIONS];

  return (
    <section
      data-testid="accreditations-section"
      className="py-16 bg-white border-y border-[var(--ac-line)]"
      aria-label="Accreditations and affiliations"
    >
      <div className="ac-container">
        <div className="text-center mb-10">
          <div className="eyebrow">Proud Partnerships</div>
          <h2 className="text-xl font-semibold text-[var(--ac-muted)] mt-2" data-testid="accreditations-heading">
            Accreditations & Affiliations
          </h2>
        </div>
      </div>

      <div className="ac-marquee overflow-hidden relative">
        <div className="ac-marquee-track px-6">
          {items.map((item, i) => {
            const isDuplicate = i >= ACCREDITATIONS.length;
            return (
              <div
                key={i}
                className="h-14 md:h-16 w-[110px] md:w-[150px] flex items-center justify-center shrink-0"
                data-testid={`accred-logo-${i}`}
                aria-hidden={isDuplicate ? "true" : undefined}
              >
                <img
                  src={item.src}
                  alt={isDuplicate ? "" : item.name}
                  title={isDuplicate ? undefined : item.name}
                  className="max-h-full max-w-full w-auto h-auto object-contain grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>
            );
          })}
        </div>
        {/* Edge fades — narrower on mobile so wide logos like NDAEB aren't cropped */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-10 md:w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-10 md:w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default Accreditations;
